import { useEffect, useRef } from 'react';
export var useSubscriptionRef = function() {
    var subscriptionRef = useRef(null);
    useEffect(function() {
        return function() {
            if (subscriptionRef.current && !subscriptionRef.current.closed) {
                subscriptionRef.current.unsubscribe();
                subscriptionRef.current = null;
            }
        };
    }, []);
    return subscriptionRef;
};
